import * as _ from 'underscore';

import { IGlob } from '../../../../pdc-platform/src/ts/Glob';
import BooleanField from '../../../../_common/platform/ts/BooleanField';
import { TitlePositionSelect } from '../../../../_common/platform/tsx/TitlePositionSelect';
import NumberField from '../../../../_common/platform/ts/NumberField';

import { validators } from '../../../../_common/platform/ts/validators';

// Theme dispatcher module
import * as appTheme from '../../../../_common/platform/ts/appTheme';
import toolbarButtons from '../../../../pdc-platform/src/ts/themes/toolbarButtonsTheme';

// Any dependency themes, which should be initialized before this one
import { init as widgetTheme } from '../../../../pdc-platform/src/ts/themes/widgetTheme';
import { themeId, moduleName, themeFields } from '../config';

// This array, which saves all glob objects, on which theme was initialized
// It's used to make sure that `init` is launched only once for each glob.
// Here, it's possible that platform will run init for widgetTheme more than 1 time.
const _init = [];

export function init(glob: IGlob) {
    // If init already invoked – halt
    if (_.indexOf(_init, glob) !== -1) {
        return;
    }

    // Init parent theme
    widgetTheme(glob);

    // Register section, which will be displayed on the left of theme edit component
    appTheme.registerSections([
        {
            id: themeId,
            name: 'Attribute Filter',
            parent: 'widget',

            themeType: 'Attribute Filter',
            visibility: ['application', 'workspace', moduleName]
        }
    ]);

    // Register theme variables
    appTheme.registerVars([
        {
            id: themeFields.showClickToFilterAttributes,
            param: new BooleanField(glob, 'Show Click-to-filter Attributes', [], true),
            section: themeId
        },
        {
            id: themeFields.titlePosition,
            param: new TitlePositionSelect(glob, undefined, undefined, { showPlaceholderAsTitle: true }),
            section: themeId
        },
        {
            id: themeFields.verticalSpacing,
            param: new NumberField(
                glob,
                'Vertical Space Between Fields',
                [validators.number.not_negative, validators.number.integer],
                10
            ),
            section: themeId
        },
        {
            id: themeFields.componentMinWidth,
            param: new NumberField(
                glob,
                'Min Width of Fields in Horizontal Layout',
                [validators.number.not_negative, validators.number.integer],
                150
            ),
            section: themeId
        },
        {
            id: themeFields.componentMaxWidth,
            param: new NumberField(
                glob,
                'Max Width of Fields in Horizontal Layout',
                [validators.number.not_negative, validators.number.integer],
                250
            ),
            section: themeId
        },
        {
            id: themeFields.labelWidth,
            param: new NumberField(
                glob,
                'Width of Field Title',
                [validators.number.not_negative, validators.number.integer],
                80
            ),
            section: themeId
        }
    ]);

    toolbarButtons(
        glob,
        themeId,
        moduleName,
        themeFields.section_Buttons,
        themeFields.justifyButtons,
        themeFields.showResetButton,
        themeFields.resetButtonShowMode,
        themeFields.showApplyButton,
        themeFields.showRefreshButton,
        themeFields.refreshButtonShowMode,
        themeFields.buttonsPosition,
        themeFields.resetButtonMode
    );

    appTheme.registerPreRender(function (input) {
        var vars = {};

        return _.extend(input, vars);
    });

    _init.push(glob);
}
